import {FunctionComponent, useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import Link from '@/components/link';
import {ROOT_PATH} from '@/constants/routes';
import {PREVIOUS_PATH_KEY} from '@/constants/storage';
import {UserProfile} from '@/repositories/beneva-api/endpoints/users';
import {WEB_CLICK_TRACKING_KEY} from '@/services/analytics/web-click-tracking-key';
import Logo from './logo';
import Menu from './menu';
import Profile from './profile';

interface ElementProps {
  profile?: UserProfile;
}

const ApplicationHeader: FunctionComponent<ElementProps> = ({profile}) => {
  const {t} = useTranslation();

  const removeHistory = useCallback(() => {
    sessionStorage.removeItem(PREVIOUS_PATH_KEY);
  }, []);

  return (
    <header className="relative grid grid-cols-3 items-center pb-4 pt-6" data-testid="application-header">
      {profile && <Menu profile={profile} />}
      <Link
        to={ROOT_PATH}
        className="col-start-2"
        onClick={removeHistory}
        data-testid="logo-link"
        aria-label={t('components.application-header.logo.accessibility-link')}
        trackingKey={WEB_CLICK_TRACKING_KEY.RETURN_TO_HOMEPAGE}
      >
        <Logo className="cursor-pointer" title={t('name')} />
      </Link>
      {profile && <Profile profile={profile} />}
    </header>
  );
};

export default ApplicationHeader;
